import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            clipRule="evenodd"
            d="M12.4243 1.71715C12.1899 1.48283 11.81 1.48283 11.5757 1.71715L10.1464 3.14644L5.67574 7.61715C5.56322 7.72967 5.5 7.88228 5.5 8.04141V9.89999C5.5 10.2314 5.76863 10.5 6.1 10.5H7.95858C8.11771 10.5 8.27032 10.4368 8.38284 10.3243L12.8536 5.85354L14.2828 4.42426C14.5172 4.18994 14.5172 3.81004 14.2828 3.57573L12.4243 1.71715ZM11.2071 3.49999L12 2.7071L13.2929 3.99999L12.5 4.79288L11.2071 3.49999ZM10.5 4.2071L11.7929 5.49999L7.79289 9.49999H6.5V8.2071L10.5 4.2071ZM3 3.99999C3 3.44771 3.44772 2.99999 4 2.99999H7.5C7.77614 2.99999 8 2.77613 8 2.49999C8 2.22385 7.77614 1.99999 7.5 1.99999H4C2.89543 1.99999 2 2.89542 2 3.99999V12C2 13.1046 2.89543 14 4 14H12C13.1046 14 14 13.1046 14 12V8.49999C14 8.22385 13.7761 7.99999 13.5 7.99999C13.2239 7.99999 13 8.22385 13 8.49999V12C13 12.5523 12.5523 13 12 13H4C3.44772 13 3 12.5523 3 12V3.99999Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default Icon;
